import React from 'react';
import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import * as ActionTypes from '../../../constants/ActionTypes';
import { merge, set as setPath } from 'lodash';

const initialState = {
    customContent: {}
};

export const customContentReducer = handleActions(
    {
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('customContent')) {
                return { ...state, customContent: action.theme.customContent };
            } else {
                return state;
            }
        },
        //TODO: temporary partial implementation of global reducer
        [ActionTypes.THEME_MODIFY_KEY]: (state, action) => {
            let pathCheck = action.path.split('.');
            if (pathCheck[0] === 'customContent') {
                pathCheck.shift();
                return merge({}, state, setPath({}, pathCheck, action.value));
            } else {
                return state;
            }
        }
    },
    initialState
);

export default customContentReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/custom-content.js